import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

export type WorkingMode = 'delivery' | 'shop'

interface WorkingModeSelectorProps {
  className?: string;
  value: WorkingMode;
  onChange: (mode: WorkingMode) => void;
}

export default function WorkingModeSelector ({
  className,
  value,
  onChange
}: WorkingModeSelectorProps) {
  const { t } = useTranslation('common')

  return (
    <div className={cn(styles.workingModeSelector, className)}>
      <button
        className={cn(styles.workingModeSelector__option, {
          [styles.workingModeSelector__optionActive]: value === 'delivery'
        })}
        onClick={() => onChange('delivery')}
        type="button"
      >
        <ReactSVG
          src="/icons/delivery.svg"
          wrapper="span"
          className={styles.workingModeSelector__icon}
        />
        <span className={styles.workingModeSelector__text}>
          {t('delivery')}
        </span>
      </button>

      <button
        className={cn(styles.workingModeSelector__option, {
          [styles.workingModeSelector__optionActive]: value === 'shop'
        })}
        onClick={() => onChange('shop')}
        type="button"
      >
        <ReactSVG
          src="/icons/pickup.svg"
          wrapper="span"
          className={styles.workingModeSelector__icon}
        />
        <span className={styles.workingModeSelector__text}>
          {t('shops')}
        </span>
      </button>
    </div>
  )
}
